import React from 'react'
import { com } from '@eidu/web'
import { Loader } from '@common/ui'
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import EntityPathPermissionContent from './EntityPathPermissionContent'
import EntityPath = com.eidu.entity.path.EntityPath
import EntityType = com.eidu.entity.type.EntityType

export type PathPermissionProps = {
  fromEntityTypeId: EntityTypeId | undefined
  preselectedPath?: EntityPath
  entityTypes: readonly EntityType[]
  onChange: (path: EntityPath | undefined) => void
  lockedToTypeId?: EntityTypeId
}

const PathPermission: React.FC<PathPermissionProps> = ({
  fromEntityTypeId,
  preselectedPath,
  entityTypes,
  onChange,
  lockedToTypeId,
}) => {
  if (entityTypes.length === 0) {
    return <Loader />
  } else {
    return (
      <EntityPathPermissionContent
        fromEntityTypeId={fromEntityTypeId}
        preselectedPath={preselectedPath}
        entityTypes={entityTypes}
        onChange={onChange}
        lockedToTypeId={lockedToTypeId}
      />
    )
  }
}

export default PathPermission
